module.exports = __webpack_public_path__ + "static/1.2_Clipboard_Icon-a2e5542fce939abb5d6b75609033a573.png";